module.exports = __webpack_public_path__ + "img/ticket_star.75f47e34.svg";